import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '@xanadu/input';

@Component({
    selector: 'input-subscriber',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class InputSubscriberComponent extends InputComponent {
    private readonly destroyRef = inject(DestroyRef);

    constructor() {
        super();

        this.destroyRef.onDestroy(() => {
            this.destroy();
        });
    }

    destroy(): void {}
}
